import { createSlice } from '@reduxjs/toolkit';

import { ITFAAction, ITFASlice } from './types';

const initialState: ITFASlice = {
  isTFADialogOpened: false,
  isTFAEndpointRefetching: false,
  tfaError: undefined,
  totp: undefined,
};

export const tfaSlice = createSlice({
  name: 'tfa',
  initialState,
  reducers: {
    setIsTFADialogOpened: (state, action: ITFAAction<'isTFADialogOpened'>) => {
      state.isTFADialogOpened = action.payload;
    },
    setIsTFAEndpointRefetching: (
      state,
      action: ITFAAction<'isTFAEndpointRefetching'>,
    ) => {
      state.isTFAEndpointRefetching = action.payload;
    },
    setTFAError: (state, action: ITFAAction<'tfaError'>) => {
      state.tfaError = action.payload;
    },
    setTOTP: (state, action: ITFAAction<'totp'>) => {
      state.totp = action.payload;
    },
    reset: () => initialState,
  },
});

export const {
  setIsTFADialogOpened,
  setIsTFAEndpointRefetching,
  setTFAError,
  setTOTP,
} = tfaSlice.actions;
